export { default as Points } from './pointsInDashboard/Points';
export { default as PointCard } from './pointCard/PointCard';
export { default as PointProfile } from './pointProfile/PointProfile';
export { default as PointInfo } from './pointInfo/PointInfo';
